import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-evo-commission-table',
  templateUrl: './campaign-evo-commission-table.component.html',
  styleUrls: ['./campaign-evo-commission-table.component.sass']
})
export class CampaignEvoCommissionTableComponent implements OnInit {
  @Input() prices: any = [];

  constructor(
  ) { }

  ngOnInit() { }
}
